import zwitCore from "./config/http";
import global from "../utils/global";
import axios from "axios";
const BASE_URL = process.env.NODE_ENV === "development" ? "/apis" : "";

const download = global.global.url + "/zw-public/web/common/downloadArticle";
export default {
  download,
  isCollect(data) {
    return zwitCore.HTTP.get(
      BASE_URL + "/zw-information/articleCollect/isCollect",
      data
    );
  },
  CollectItem(data) {
    return zwitCore.HTTP.json(
      BASE_URL + "/zw-information/articleCollect/addOrDelCollect",
      data
    );
  },
  async CollectItemAPP(data) {
    return await axios({
      url: `${BASE_URL}/zw-information/articleCollect/addOrDelCollect`,
      method: "post",
      data,
      headers: {
        rsa: "no",
      },
    });
  },

  downPdf(data) {
    return zwitCore.HTTP.get(BASE_URL + "/zw-public/web/common/download", data);
  },
  getRecomendList(params) {
    return zwitCore.HTTP.post(BASE_URL + "/zw-user/org/nf/detail", params);
  },
  getTable() {
    return zwitCore.HTTP.get(BASE_URL + "/zw-public/dictionaries/info");
  },
  getDetails(params) {
    return zwitCore.HTTP.get(
      BASE_URL + "/zw-information/articleInfo/getDetails",
      params,
      false
    );
  },
  getMeetingDetails(params) {
    return zwitCore.HTTP.get(
      BASE_URL + "/zw-information/articleMeeting/detail",
      params,
      false
    );
  },
  getPublisher(params) {
    return zwitCore.HTTP.get(
      BASE_URL + "/zw-information/articleMeeting/detailList",
      params,
      false
    );
  },
  getListByOrgId(params) {
    return zwitCore.HTTP.get(
      BASE_URL + "/zw-information/articleMeeting/listByOrgId",
      params,
      false
    );
  },
  getwenxian(params) {
    return zwitCore.HTTP.get(
      BASE_URL + "/zw-information/articleInfo/getBeSimilarList",
      params,
      false
    );
  },
  getAuthor(data) {
    return zwitCore.HTTP.post(
      BASE_URL + "/zw-user/searchUser/nf/findArticleReleaseNameById",
      data,
      false
    );
  },
  async getAuthorList(data) {
    return await axios({
      url: `${BASE_URL}/zw-user/searchUser/nf/getAuthorByUserId`,
      method: "post",
      data,
      headers: {
        rsa: "no",
      },
    });
  },
  periodical(data) {
    return zwitCore.HTTP.post(
      BASE_URL + "/zw-user/periodical/nf/detail",
      data,
      false
    );
  },
  periodiID(data) {
    return zwitCore.HTTP.get(
      BASE_URL + "/zw-information/articleInfo/getPeriodicalCount",
      data,
      false
    );
  },
  PublisherInfo(data) {
    return zwitCore.HTTP.get(
      BASE_URL + "/zw-information/articleInfo/getCreateUserCount",
      data,
      false
    );
  },
  solicitation(data) {
    return zwitCore.HTTP.get(
      BASE_URL + "/zw-knowledge/solicitation/detail",
      data,
      false
    );
  },
  videoDetails(data) {
    return zwitCore.HTTP.get(
      BASE_URL + "/zw-information/articleVideo/detail",
      data,
      false
    );
  },
  newVideos(data) {
    return zwitCore.HTTP.get(
      BASE_URL + "/zw-information/articleVideo/newestList",
      data,
      false
    );
  },
  bookToCollect(data) {
    return zwitCore.HTTP.post(
      BASE_URL + "/zw-goods/goodsCollect/nf/updateUserCollect",
      data,
      false
    );
  },
};
